
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CATOLCUIC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CATOLCUIC.vue